/* eslint-disable @typescript-eslint/brace-style */
import { Stack, DetailsList, SelectionMode, Spinner } from '@fluentui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAllSoscallEntries } from '../../assets/axios/services'
import { Columns } from '../../assets/consts/Columns'
import PageNavigation from '../styledComponents/PageNavigation'
import StyledButton from '../styledComponents/StyledButton'
import { SosCallStyle } from './SosCall.style'

export default function SosCallList () {
  const style = SosCallStyle()
  const navigate = useNavigate()
  const [pagination, setPagination] = useState({})
  const [actionInProgress, setActionInProgress] = useState(false)

  const [data, setData] = useState([])
  const [filter, setFilter] = useState({
    page: 1,
    searchBy: null,
    sortBy: 'created_date',
    sortAsc: false
  })

  const onPageChange = (page: any) => {
    setFilter({ ...filter, page })
  }
  useEffect(() => {
    setActionInProgress(true)
    getAllSoscallEntries(filter).then((res) => {
      setData(res.data.items)
      setPagination({
        total: res.data.total,
        page: res.data.page,
        size: res.data.size
      })
      setActionInProgress(false)
    }
    )
  }, [filter])

  let searchTimeout: any = null

  const onSearch = (searchBy: any) => {
    if (searchBy.length > 2) {
      if (searchTimeout) clearTimeout(searchTimeout)
      searchTimeout = setTimeout(() => {
        if (filter.searchBy !== searchBy) {
          setFilter({ ...filter, searchBy })
        }
      }, 1000)
    }
    else {
      setFilter({ ...filter, searchBy: null })
    }
  }

  const onRender = (item: any, index: any, column: any) => {
    if (column != null) {
      switch (column?.key) {
        case 'moreButton':
          return (
            <Stack style={ style.row } horizontalAlign='end'>
              <StyledButton
          height='20px'
          onClick={ () => {
            navigate(`/services/soscall/${item.id}`)
          } }
          text='Pregledaj'
          />
            </Stack>
          )

        case 'created_date':
          return (<>{ moment(item[column?.key]).format('DD.MM.YYYY') }</>)

        case 'victim':
          return (<>{ item.anonymous === true ? 'Anonimni poziv' : `${item.victim_first_name} ${item.victim_last_name}` }</>)

        case 'perpetrator':
          return (<>{ `${item.perpetrator_first_name ?? ''} ${item.perpetrator_last_name ?? ''}` }</>)

        default:
          return (<>{ item[column?.key] }</>)
      }
    }
  }

  return (
    <Stack style={{ maxWidth: '1000px' }}>
      <Stack horizontal style={ style.topRow } horizontalAlign='space-between' verticalAlign='center'>
        <PageNavigation pagination={ pagination } onPageChange={ onPageChange } onSearch={ onSearch }/>
        <StyledButton
        text='Dodaj'
        onClick={ () => { navigate('/services/soscall/new') } }
        />
      </Stack>
      { actionInProgress
        ? <Spinner style={{ paddingTop: '50px' }}/>
        : <> <DetailsList
      onRenderItemColumn={ onRender }
      items={ data }
      columns={ Columns((sortBy: any) => setFilter({ ...filter, sortBy, sortAsc: !(filter.sortAsc) }),
        filter.sortAsc, filter.sortBy).SosCallColumns }
      selectionMode={ SelectionMode.none }
      />
          { data.length === 0 &&
            <Stack horizontal horizontalAlign='center' style={{ userSelect: 'none' }}>
              nema podataka
            </Stack> }
        </>
       }
    </Stack>
  )
}
